// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "leg-3uu2e";
var _3 = "header__cities-2McDe";
export { _1 as "__esModule", _2 as "leg", _3 as "header__cities" }
export default { "__esModule": _1, "leg": _2, "header__cities": _3 }
